import { Modal } from "react-bootstrap";
import Button from "app/storybookComponents/Button";
import { ReactNode } from "react";

export interface BaseModalProps {
  show?: boolean;
  onHide: () => void;
}

interface Props extends BaseModalProps {
  titleSmallText?: string;
  title?: string;
  className?: string;
  children?: ReactNode;
  size?: "sm" | "lg" | "xl";
  enforceFocus?: boolean;
  centered?: boolean;
  additionalCloseButtonContent?: ReactNode | null;
  backdrop?: boolean | "static";
}

const SimpleModal = ({
  show,
  onHide,
  children,
  title,
  className = "",
  titleSmallText,
  size = "lg",
  enforceFocus = true,
  centered = false,
  additionalCloseButtonContent,
  backdrop,
}: Readonly<Props>) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size}
      className={`simple-modal ${className}`}
      enforceFocus={enforceFocus}
      centered={centered}
      backdrop={backdrop}
    >
      <div className="modal-title-row">
        <div className="column-gap-12px">
          {titleSmallText ? (
            <p className="small-body-text">{titleSmallText}</p>
          ) : null}
          <h2>{title}</h2>
        </div>
        <div>
          {additionalCloseButtonContent}
          <Button
            onClick={() => onHide()}
            variant={"secondary-blue"}
            style={{ border: "none", width: "auto" }}
            xIcon
          />
        </div>
      </div>
      {children}
    </Modal>
  );
};

export default SimpleModal;
